import { CLAIMS_NS, decodeTokenPayload } from '@zealot/shared';
import { getValidAuthToken } from '@/utils/auth';

// gloss
export const getTokenBrandData = (): Record<string, unknown> | null => {
  const authToken = getValidAuthToken();
  if (!authToken) return null;

  const payload = decodeTokenPayload(authToken.token) as Record<string, unknown> | null;
  if (!payload) return payload;

  return {
    ...payload,
    brandUuid: payload.brandUuid ?? payload[`${CLAIMS_NS}/brand_uuid`],
    brandID: payload.brandID ?? payload[`${CLAIMS_NS}/brand_id`],
    brand: payload.brand ?? payload[`${CLAIMS_NS}/brand_code`],
  };
};
